import { Component, Input } from '@angular/core';
import { Observable } from 'rxjs';
import { ImageDto } from 'src/app/models/image-dto';
import { MultiLangStrDto } from 'src/app/models/multi-lang-str-dto';

interface ConservationShapeEntity {
  entityId: number;
  entityType: string;
}

interface ConservationMapShape {
  shapeId: number;
  shapeWkt: string;
  shapeData: {
    entity: ConservationShapeEntity;
  };
}

interface ConservationArchiveImageView {
  imageId: number;
  imageNumber: number;
  imageUrl: string;
}

export interface ConservationArchiveDocumentView {
  entityId: number;
  documentLongId: string;
  folderEntityId: number;
  folderLongId: string;
  docNumber: number;
  mediaType: MultiLangStrDto;
  boxId: number | null;
  documentType: MultiLangStrDto;
  documentTitle: MultiLangStrDto;
  depositionDate: string;
  totalPages: number | null;
  hasScan: boolean;
  documentDownloadUrl: string;
  siteId: number | null;
  siteSubId: number | null;
  siteEntityId: number;
  siteName: string;
  siteType: string;
  images: ConservationArchiveImageView[];
  archiveMapInformation: ConservationMapShape[];
}

@Component({
  selector: 'conservation-archive-document-details',
  templateUrl: './conservation-archive-document-details.component.html',
  styleUrls: ['./conservation-archive-document-details.component.scss'],
})
export class ConservationArchiveDocumentDetailsComponent {
  @Input() details!: ConservationArchiveDocumentView;
  @Input() currentLanguage!: Observable<string>;
  @Input() onViewFolder!: (entityId: number) => void;
  @Input() onViewSite!: (entityId: number) => void;
  @Input() onDownload!: () => void;

  get canNavigateToFolder(): boolean {
    return (this.details?.folderEntityId || 0) > 0;
  }

  get hasSiteData(): boolean {
    return (this.details?.siteEntityId || 0) > 0
      || (this.details?.siteId || 0) > 0
      || !!(this.details?.siteName && this.details.siteName.trim().length > 0)
      || !!(this.details?.siteType && this.details.siteType.trim().length > 0);
  }

  get canNavigateToSite(): boolean {
    return (this.details?.siteEntityId || 0) > 0 && this.details?.siteEntityId !== 0;
  }

  get images(): ImageDto[] {
    if (!this.details?.hasScan || !this.details?.images?.length) {
      return [];
    }

    return this.details.images.map((img) => new ImageDto(String(img.imageId || img.imageNumber), img.imageUrl));
  }

  get thumbnails(): ImageDto[] {
    return this.images.map((img) => {
      const thumbUrl = img.imageUrl.includes('?')
        ? `${img.imageUrl}&type=thumbnail`
        : `${img.imageUrl}?type=thumbnail`;
      return new ImageDto(img.imageId, thumbUrl);
    });
  }

}

